if (!customElements.get('ept-bulk')) {
  customElements.define('ept-bulk', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.rowIndex = 0;
      this.form = this.querySelector('[data-bulk-form]');
      this.rows = this.querySelector('[data-rows]');
      this.submit = this.querySelector('[data-submit]');
      this.error = this.querySelector('[data-error]');
      this.money = new Intl.NumberFormat('nb-NO', {style: 'currency', currency: 'NOK'});
      this.querySelector('[data-add]').addEventListener('click', () => this.addRow(true));
      this.form.addEventListener('input', () => this.update());
      this.form.addEventListener('change', () => this.update());
      this.form.addEventListener('submit', (event) => this.send(event));
      this.addRow(false);
    }
    addRow(focus) {
      const fragment = this.querySelector('[data-row-template]').content.cloneNode(true);
      const row = fragment.querySelector('[data-remove]').closest('fieldset');
      const unique = this.id || this.form.id;
      this.rowIndex += 1;
      for (const field of row.querySelectorAll('[data-field]')) {
        field.id = unique + '-' + this.rowIndex + '-' + field.dataset.field;
        row.querySelector('[data-label="' + field.dataset.field + '"]').htmlFor = field.id;
      }
      row.querySelector('[data-remove]').addEventListener('click', () => {
        row.remove();
        if (!this.rows.children.length) this.addRow(false);
        this.update();
        this.querySelector('[data-add]').focus();
      });
      this.rows.appendChild(fragment);
      this.update();
      if (focus) row.querySelector('select').focus();
    }
    values() {
      return [...this.rows.children].map(row => {
        const get = key => row.querySelector('[data-field="' + key + '"]')?.value || '';
        return {model: get('model'), color: get('color'), size: get('size'), quantity: Number(get('quantity'))};
      });
    }
    update() {
      [...this.rows.children].forEach((row, i) => {
        row.querySelector('[data-row-number]').textContent = String(i + 1);
      });
      const values = this.values();
      const total = values.reduce((sum, value) => sum + (Number.isInteger(value.quantity) && value.quantity > 0 ? value.quantity : 0), 0);
      this.querySelector('[data-count]').textContent = String(total);
      this.querySelector('[data-subtotal]').textContent = this.money.format(total * Number(this.dataset.price) / 100);
      const quote = total >= 5 && total < 10;
      this.querySelector('[data-fee-line]').hidden = !quote;
      this.querySelector('[data-fee]').textContent = this.money.format(450);
      this.submit.textContent = this.dataset.cartText;
      this.error.textContent = '';
      this.querySelector('[data-total-price]').textContent = this.money.format(total * Number(this.dataset.price) / 100 + (quote ? 450 : 0));
    }
    async send(event) {
      event.preventDefault();
      if (!this.form.reportValidity()) return;
      const values = this.values();
      if (values.some(value => !Number.isInteger(value.quantity) || value.quantity < 1 || value.quantity > 1000 || !value.size || !(value.model || value.color))) return;
      const total = values.reduce((sum, value) => sum + value.quantity, 0);
      if (total < 5) {
        this.error.textContent = this.dataset.minimumError;
        return;
      }
      const club = this.querySelector('[data-club-input]')?.value.trim() || '';
      if (this.dataset.club === 'true' && !club) {
        this.error.textContent = this.dataset.clubError;
        this.querySelector('[data-club-input]').focus();
        return;
      }
      if (this.dataset.available !== 'true') {
        this.error.textContent = this.dataset.unavailableText;
        return;
      }
      const items = values.map(value => {
        const properties = {'Størrelse': value.size};
        if (value.model) properties['Modell'] = value.model;
        if (value.color) properties['Farge'] = value.color;
        if (club) properties['Klubbnavn'] = club;
        return {id: this.dataset.variant, quantity: value.quantity, properties};
      });
      this.submit.disabled = true;
      this.submit.textContent = this.dataset.waitText;
      let added = false;
      try {
        const root = this.dataset.root.endsWith('/') ? this.dataset.root : this.dataset.root + '/';
        const response = await fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
          body: JSON.stringify({items})
        });
        const result = await response.json();
        if (!response.ok || result.status) throw new Error();
        added = true;
        await window.EptOrder.sync();
        location.assign(this.dataset.cart);
      } catch {
        if (added) {
          location.assign(this.dataset.cart);
          return;
        }
        this.error.textContent = this.dataset.errorText;
        this.submit.disabled = false;
        this.submit.textContent = this.dataset.cartText;
      }
    }
  });
}

